export default __webpack_public_path__ + "static/media/info-raca.786737ac.png";